import { IconMail } from '@tabler/icons-react';
import NSIcon from 'bricks/NSIcon/NSIcon';
import { NSCard, NSButton } from 'bricks';
import { CardBody } from 'reactstrap';
import { URLS } from 'services/urls';
import { IContact } from '../types';

const ContactCard = ({
    name, jobTitle, id, email,
}: IContact) => {
    const handleCardClick = () => {
        window.location.href = URLS.PROJECTS_APP.CONTACT_DETAILS(id);
    };

    return (
        <NSCard
            className="NSCard--level-3 p-2 my-2 cursor--pointer"
            onClick={handleCardClick}
        >
            <CardBody className="d-flex justify-content-between align-items-center p-0">
                <div>
                    <span className="text-dark d-block">{name}</span>
                    <div className="d-flex align-items-center">
                        <small className="text-muted">{jobTitle}</small>
                    </div>
                </div>
                {email && (
                    <NSButton
                        color="link"
                        className="text-muted p-0"
                        callback={(e: React.MouseEvent) => {
                            e.stopPropagation();
                            window.location.href = `mailto:${email}`;
                        }}
                    >
                        <NSIcon icon={IconMail} size="lg" />
                    </NSButton>
                )}
            </CardBody>
        </NSCard>
    );
};
export default ContactCard;
